import { render, staticRenderFns } from "./OtherCandidates.vue?vue&type=template&id=ff6ba8a6"
import script from "./OtherCandidates.vue?vue&type=script&lang=js"
export * from "./OtherCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports